import styled, { CSSProperties } from 'styled-components';

type TPreProps = {
    $whiteSpace?: CSSProperties['whiteSpace'],
    $withIndent?: boolean,
}

export const Pre = styled.pre<TPreProps>`
    white-space: ${({ $whiteSpace = 'pre' }) => $whiteSpace};
    margin: ${({ $withIndent = true }) => $withIndent ? 'revert' : '0'};
`;
